export default {
  'rankMember.title': 'Hạng thành viên',
  'rankMember.rankMemberTab': 'Hạng thành viên',
  'rankMember.accumulatedTab': 'Lũy kế',
  'rankMember.rankName': 'Tên hạng',
  'rankMember.accumulatedSponsor': 'Lũy kế tài trợ',
  'rankMember.accumulatedPerYear': 'Mức lũy kế hằng năm',
  'rankMember.placeholder.accumulatedPerYear': 'Nhập mức lũy kế',
};
